var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cutout-check"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 12.4 L9.8 16 L17.8 8",
    fill: "none",
    stroke: "black",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0dcaf0",
    mask: "url(#cutout-check)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/blue_check.73c33ce54f726508bfb0685f15691c51.svg";
export { ForwardRef as ReactComponent };